import DownloadFileButton from "../../components/downloadFileButton/DownloadFileButton";
import type { FC } from "react";
import { useSnackbar } from "notistack";
import TableRowsIcon from "@mui/icons-material/TableRows";

interface Props {
  readonly buttonText: string;
  readonly filename: string;
  readonly getFile: () => Promise<Blob>;
}

const DownloadParticipantListTemplateButton: FC<Props> = ({ filename, buttonText, getFile }) => {
  const { enqueueSnackbar } = useSnackbar();

  return (
    <DownloadFileButton
      startIcon={<TableRowsIcon />}
      buttonText={buttonText}
      options={[{ name: buttonText, apiDefinition: getFile }]}
      filename={filename}
      onError={() =>
        enqueueSnackbar(`Nie udało się pobrać pliku ${filename}`, {
          variant: "error",
        })
      }
    />
  );
};

export default DownloadParticipantListTemplateButton;
